module.exports = __webpack_public_path__ + "static/media/am.0968d4cf.svg";